export enum DefaultHomePageCode {
  PatientSearch = 'PGSRH',
  Dashboard = 'PGDSH'
}
